import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface Column<T> {
  key: string;
  header: string;
  render: (row: T) => ReactNode;
  align?: 'left' | 'right';
  hideOnMobile?: boolean;
}

export interface DataTableProps<T> {
  columns: readonly Column<T>[];
  rows: readonly T[];
  rowKey: (row: T) => string;
  caption: string;
  className?: string;
}

/** Tablice admina. Vodoravni scroll je u kontejneru, stranica se nikad ne pomiče bočno. */
export function DataTable<T>({ columns, rows, rowKey, caption, className }: DataTableProps<T>) {
  return (
    <div
      className={cx(
        'overflow-x-auto rounded-xl border border-line-subtle bg-surface shadow-card',
        className,
      )}
    >
      <table className="w-full min-w-[36rem] border-collapse text-left">
        <caption className="sr-only">{caption}</caption>
        <thead>
          <tr className="border-b border-line-subtle">
            {columns.map((c) => (
              <th
                key={c.key}
                scope="col"
                className={cx(
                  'px-4 py-3 text-[11px] uppercase tracking-[2px] text-ink-muted',
                  c.align === 'right' && 'text-right',
                  c.hideOnMobile && 'hidden md:table-cell',
                )}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)} className="border-b border-line-subtle last:border-b-0">
              {columns.map((c) => (
                <td
                  key={c.key}
                  className={cx(
                    'px-4 py-3 text-[14px] text-ink',
                    c.align === 'right' && 'text-right',
                    c.hideOnMobile && 'hidden md:table-cell',
                  )}
                >
                  {c.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
